/**
 * 读取当前登录用户邮箱（Android Local 接口 username 字段）。
 * @returns {string}
 */
export const readUserEmail = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}')?.data?.email || ''
  } catch {
    return ''
  }
}

const readJson = key => {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null')
  } catch {
    return null
  }
}

/** 读取当前 Android Local 选中 user-device 记录的原始 iCloud_username。 */
export const readLocalDeviceICloudUsername = () => {
  if (typeof window === 'undefined') return ''

  const deviceUser = readJson('DeviceUser') || {}
  const selectedId = deviceUser.device_id ?? deviceUser.id
  const sameId = item => {
    const row = item?.DeviceUser || item
    const rowId = row?.id ?? row?.device_id

    return selectedId != null && rowId != null && String(rowId) === String(selectedId)
  }
  const devices = readJson('allDeviceUser')
  const selectedFromList = Array.isArray(devices) ? devices.find(sameId) : null
  const currentDevice = readJson('currentDevice')
  const selectedFromCurrent = sameId(currentDevice) ? currentDevice : null
  const currentRecord =
    selectedFromList?.DeviceUser ||
    selectedFromList ||
    selectedFromCurrent?.DeviceUser ||
    selectedFromCurrent

  if (currentRecord?.iCloud_username) return String(currentRecord.iCloud_username).trim()

  // DeviceUser.username is canonical iCloud_username after the Android-Local switch fix.
  // If it equals the package ID, treat it as legacy data and avoid sending that ID.
  const username = String(deviceUser.username || '').trim()

  return username && (selectedId == null || username !== String(selectedId)) ? username : ''
}

/**
 * 读取 Android Local 请求使用的设备标识。
 * Android-Local 的 UDID 就是 user-device.iCloud_username，既不是包 ID（device_id / id），
 * 也不能用登录账号邮箱；传错值时网关按设备查不到数据，拦截限制缓存也会读成空。
 * @param {Object} [context] - deviceContext，来自 Redux 或 readStoredDeviceContext
 * @returns {string}
 */
export const readLocalDeviceUdid = context => {
  const accountId = String(context?.accountId ?? '').trim()
  const username = String(context?.username ?? '').trim()

  // context.username 为 iCloud_username；与包 ID 相同说明是旧存储，继续走本地反查
  if (username && username !== accountId) return username

  return readLocalDeviceICloudUsername()
}
